import { router } from '@/modules/quan-ly-quy-trinh/router'

export default router
